export default __webpack_public_path__ + "static/media/success-activate-account.375ff4df.svg";